import { useTranslation } from 'react-i18next';
import { Card, Tabs, Typography, Flex } from 'antd';
import { IconDatabase } from '@tabler/icons-react';
import type { ComponentSchemaManagerViewProps } from './ComponentSchemaManager.types';
import { AssociationTransferModalContainer } from '~/app/components/knowledgeBase/associationTransferModal';
import { AssetTypeManufacturerModelCreateModal } from '~/app/components/knowledgeBase/AssetTypeManufacturerModelCreateModal/AssetTypeManufacturerModelCreateModal';
import {
  containerStyle,
  headerStyle,
  cardStyle,
} from './ComponentSchemaManager.style';

const { Title, Paragraph } = Typography;

export const ComponentSchemaManager = ({
  tabItems,
  activeTab,
  onTabChange,
  transferModal,
  transferTargetItems,
  transferSelectedKeys,
  onSaveTransfer,
  onCloseTransfer,
  atmmCreateOpen,
  onCloseAtmmCreate,
  onAtmmCreateSuccess,
}: ComponentSchemaManagerViewProps) => {
  const { t } = useTranslation('componentSchema');

  return (
    <Flex vertical style={containerStyle}>
      <Flex style={headerStyle}>
        <Flex vertical gap={4}>
          <Flex align="center" gap={12}>
            <IconDatabase size={28} color="#1E6DF6" stroke={1.5} />
            <Title level={3} style={{ margin: 0 }}>
              {t('header.title')}
            </Title>
          </Flex>
          <Paragraph
            type="secondary"
            style={{ margin: 0, paddingLeft: 40, fontSize: 14 }}
          >
            {t('header.description')}
          </Paragraph>
        </Flex>
      </Flex>

      <Card style={cardStyle}>
        <Tabs
          activeKey={activeTab}
          onChange={onTabChange}
          type="card"
          items={tabItems}
          tabBarStyle={{ marginBottom: 24 }}
        />
      </Card>

      <AssociationTransferModalContainer
        open={transferModal.open}
        sourceConfigName={transferModal.sourceConfigName}
        sourceId={transferModal.sourceId}
        sourceCode={transferModal.sourceCode}
        sourceName={transferModal.sourceName}
        targetConfigName={transferModal.targetConfigName}
        targetItems={transferTargetItems}
        selectedKeys={transferSelectedKeys}
        onTransfer={onSaveTransfer}
        onClose={onCloseTransfer}
      />

      <AssetTypeManufacturerModelCreateModal
        open={atmmCreateOpen}
        onClose={onCloseAtmmCreate}
        onSuccess={onAtmmCreateSuccess}
      />
    </Flex>
  );
};
